import { Component } from '@angular/core';

import { TranslationService, setGlobalTranslationService } from '@lib/translation';

@Component({
  selector: 'fm-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  public title = 'fusus-meet';

  constructor(private readonly _translationService: TranslationService) {
    setGlobalTranslationService(this._translationService);
  }
}
